import type { SelectOptionType } from "@bp/ui-components/dist/@bp/lib/Select/Select";

/** Minimal profile shape the option label needs. */
export type LinkableProfile = {
  uuid: string;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  user?: { uuid?: string } | null;
};

export function profileOptionLabel(profile: LinkableProfile): string {
  const name = `${profile.lastName ?? ""}, ${profile.firstName ?? ""}`.trim().replace(/^,\s*/, "");
  const label = name || profile.email || profile.uuid;
  return profile.email && name ? `${label} — ${profile.email}` : label;
}

/** Only profiles without a login account can be attached to an existing account. */
export function selectableProfiles(
  profiles: ReadonlyArray<LinkableProfile> | undefined,
): LinkableProfile[] {
  return (profiles ?? []).filter((p) => !p.user?.uuid);
}

export function profileOptions(
  profiles: ReadonlyArray<LinkableProfile> | undefined,
): SelectOptionType[] {
  return selectableProfiles(profiles).map((p) => ({
    value: p.uuid,
    label: profileOptionLabel(p),
  }));
}
